module.exports = __webpack_public_path__ + "img/devices-logo.f76299c7.svg";